import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const ApplePayResult = () => {
  return <CommonResult />;
};

export default ApplePayResult;
